import { createContext } from 'react';
import noop from 'lodash/noop';

type FormContextProps = {
  errors: any;
  item: any;
  onBlur?: Function;
  overrideState?: Function;
  resetError?: any;
  save: any;
  updateState: (newAttrs: Object, parameters?: { replaceArrayValues?: boolean }) => void;
  validateState?: any;
  workingState: Object;
};

const FormContext = createContext<FormContextProps>({
  errors: null,
  item: null,
  onBlur: noop,
  overrideState: noop,
  resetError: noop,
  save: null,
  updateState: noop,
  validateState: noop,
  workingState: {},
});

export default FormContext;
